export const BUSINESS_ENTERPRISE_SUCCESS_CTA_MESSAGE = {
  "en": "Take control of your password security—start shielding employee access with Dashlane today.",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Take control of your password security—start shielding employee access with Dashlane today.",
  "it": "Take control of your password security—start shielding employee access with Dashlane today.",
  "ja": "Take control of your password security—start shielding employee access with Dashlane today.",
  "ko": "Take control of your password security—start shielding employee access with Dashlane today.",
  "nl": "Take control of your password security—start shielding employee access with Dashlane today.",
  "pt-pt": "Take control of your password security—start shielding employee access with Dashlane today.",
  "sv": "Take control of your password security—start shielding employee access with Dashlane today.",
  "zh": "Take control of your password security—start shielding employee access with Dashlane today."
}